import { Color, Header, Paragraph } from '@eggplant/pattern-library'
import type { CSSProperties } from 'react'

const pageTitleWrapper: CSSProperties = {
  display: 'grid',
  rowGap: '8px'
}

const description = `We imported your requirements file, but it contains invalid entries in the requirement ID and description 

columns. These columns contain non-plain text or empty cells. To maintain database integrity, we did not 

import these entries. Please see the details below:`

const RequirementsWarningTitle = () =>
  <div style={pageTitleWrapper}>
    <Header
      hasNoTopMargin
      rank={2}
    >
      File contains invalid entries
    </Header>
    <Paragraph>
      <Color variant='theme-description-text'>
        {description}
      </Color>
    </Paragraph>
  </div>

export default RequirementsWarningTitle
